import moment from "moment";

export const formatReservationFormat = ({ reservation, language = "en" }) => {
  // Set moment locale based on language
  moment.locale(language);

  // Parse the date and time using moment
  const date = moment(reservation.date, "DD/MM/YY");
  const time = moment(reservation.time, "HH:mm");

  // Format based on language
  if (language === "de") {
    // German format
    const formattedDate = date.format("dddd, D. MMMM YYYY");
    const formattedTime = time.format("HH:mm");
    const guests = reservation.person.split("_")[0];
    return `${formattedDate}, ${formattedTime} Uhr, ${guests} Gäste`;
  } else {
    // English format
    const formattedDate = date.format("dddd, MMMM D, YYYY");
    const formattedTime = time.format("hh:mm A");
    const guests = reservation.person.split("_")[0];
    return `${formattedDate}, ${formattedTime}, ${guests} guests`;
  }
};
